window.addEventListener('scroll', function() {
    var scrollPosition = window.scrollY;
    var parallaxElements = document.querySelectorAll('.block-image-paralax-new__parallax');

    parallaxElements.forEach(function(element) {
        var parallaxOffset = element.parentElement.offsetTop;
        var screenWidth = window.innerWidth;
        var parallaxSpeed ;
        if (screenWidth < 992) {
            parallaxSpeed = 0.15;
        } else if (screenWidth < 1400) {
            parallaxSpeed = 0.4;
        } else if (screenWidth < 2000) {
            parallaxSpeed = 0.4;
        } else {
            parallaxSpeed = 0.1;
        }

        var imageHeight = element.clientHeight; // Висота зображення

        var parallaxTranslate = (scrollPosition - parallaxOffset) * parallaxSpeed;

        // if (parallaxTranslate > 0) {
        //     parallaxTranslate = 0;
        // } else if (Math.abs(parallaxTranslate) > imageHeight) {
        //     parallaxTranslate = -imageHeight;
        // }

        element.style.transform = 'translate(-50%, calc(-50% + ' + parallaxTranslate + 'px))';
    });
});